<template>
  <div class="disclaimerPloicy">
    <section class="main_section">
      <div class="page-contentbox">
        <a @click="goBack" class="back-link">
          <i class="material-icons">arrow_back_ios</i> Back
        </a>
        <h2>Disclaimer Policy</h2>

        <p>
          The information contained in this website is for general information purposes only.
          The information is provided by Rovi91 Innovations Pvt Ltd, a property of Rovi91 Innovations Pvt Ltd.
          While we endeavor to keep the information up to date and correct, we make no
          representations or warranties of any kind, express or implied, about the completeness,
          accuracy, reliability, suitability or availability with respect to the website or the
          information, products, services, or related graphics contained on the website for any
          purpose. Any reliance you place on such information is therefore strictly at your own
          risk.
        </p>

        <p>
          In no event will we be liable for any loss or damage including without limitation,
          indirect or consequential loss or damage, or any loss or damage whatsoever arising
          from loss of data or profits arising out of, or in connection with, the use of this
          website.
        </p>

        <p>
          Through this website you are able to link to other websites which are not under the
          control of Rovi91 Innovations Pvt Ltd. We have no control over the nature, content and
          availability of those sites. The inclusion of any links does not necessarily imply a
          recommendation or endorse the views expressed within them.
        </p>

        <p>
          Every effort is made to keep the website up and running smoothly. However,
          Rovi91 Innovations Pvt Ltd takes no responsibility for, and will not be liable for, the website
          being temporarily unavailable due to technical issues beyond our control.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "DisclaimerPolicy",
  data() {
    return {
      msg: "Welcome to Your Vue.js PWA"
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
